export default "__VITE_ASSET__D003t6fN__"